  $(document).ready(function() {

    if( jQuery('fieldset').hasClass('evdpl_product') && jQuery('fieldset').hasClass('evdpl_color')){
      jQuery("fieldset").hide();      
      jQuery("options-selection[data-options-selection]").addClass('evdpl_product_overlay');
      jQuery("options-selection[data-options-selection]").after("<span id=evdpl_product_overlay class=evdpl_product_overlay></span>");      
    }
     
    $('.titleWithSlider .sliderWrap').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      dots: false,
      arrows: true,
      variableWidth: true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg width="12" height="20" viewBox="0 0 12 20" fill="black" xmlns="http://www.w3.org/2000/svg"> <path d="M0.827191 10.5488L10.0778 19.7738C10.3809 20.0759 10.8716 20.0754 11.1741 19.7723C11.4765 19.4692 11.4757 18.9782 11.1726 18.6759L2.47261 9.99997L11.1729 1.32406C11.476 1.02172 11.4768 0.531057 11.1745 0.227934C11.0228 0.0759812 10.8241 3.86511e-06 10.6254 3.88248e-06C10.4272 3.89981e-06 10.2292 0.0754739 10.0778 0.226372L0.82719 9.45114C0.681214 9.59637 0.5993 9.79403 0.5993 9.99997C0.5993 10.2059 0.681449 10.4033 0.827191 10.5488Z"/> </svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg width="12" height="20" viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg" fill="black"> <path d="M11.1728 9.45117L1.92222 0.226167C1.61913 -0.0759023 1.12843 -0.0753945 0.825857 0.227729C0.523514 0.530814 0.524296 1.02179 0.82742 1.32409L9.52739 10L0.827107 18.6759C0.524022 18.9783 0.523241 19.4689 0.825544 19.7721C0.977223 19.924 1.17593 20 1.37464 20C1.57285 20 1.77078 19.9245 1.92218 19.7736L11.1728 10.5489C11.3188 10.4036 11.4007 10.206 11.4007 10C11.4007 9.7941 11.3186 9.59668 11.1728 9.45117Z"/> </svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            centerMode: false,
          }
        }
      ],    
    });
    $('.homeSlider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
      // load when swatch exist on page for the color
   function sortColorsElem() {
     
     var evdpl_sorted_colors = jQuery('.evdpl_color .swatch__option');
     var prepand_elem = [];
     var exclude_colr = ['black','chocolate','cognac','cigar'];
     
     if (jQuery('div [data-evdplcolor-variant="black"]').length > 0) {
            prepand_elem.push(jQuery('div [data-evdplcolor-variant="black"]'));
        }

        if (jQuery('div [data-evdplcolor-variant="chocolate"]').length > 0) {
            prepand_elem.push(jQuery('div [data-evdplcolor-variant="chocolate"]'));
        }

        if (jQuery('div [data-evdplcolor-variant="cognac"]').length > 0) {
            prepand_elem.push(jQuery('div [data-evdplcolor-variant="cognac"]'));
        }

        if (jQuery('div [data-evdplcolor-variant="cigar"]').length > 0) {
            prepand_elem.push(jQuery('div [data-evdplcolor-variant="cigar"]'));
        }
     $.each(evdpl_sorted_colors, function(key,val) {       
       currt_color = jQuery(val).data('evdplcolor-variant');
       
       if(jQuery.inArray(currt_color, exclude_colr) === -1) {
          prepand_elem.push(val);
       }
     });
      jQuery('.evdpl_color .swatch__options').empty();     
      jQuery('.evdpl_color .swatch__options').append(prepand_elem);
      jQuery("fieldset").show();
     
      setTimeout(function () {
         jQuery("options-selection[data-options-selection]").removeClass('evdpl_product_overlay');
         jQuery("span#evdpl_product_overlay").removeClass('evdpl_product_overlay');                  
        },300);
      
    }
    
    if( jQuery('fieldset').hasClass('evdpl_product') && jQuery('fieldset').hasClass('evdpl_color') ){
       setTimeout(function() {
          sortColorsElem();
        }, 1300);
      
       $(document).on('click','.swatch__option input',function(){
        // console.log("Submit button is clicked!");
          jQuery("options-selection[data-options-selection]").addClass('evdpl_product_overlay');
         jQuery("span#evdpl_product_overlay").addClass('evdpl_product_overlay');
         setTimeout(function() {
          sortColorsElem();          
        }, 200);
        // event.preventDefault();
       });
    }
    
    // load when search page 
    if (jQuery("body").hasClass("search")) {
  
    var evdpl_searchcount = jQuery('.product-wrap').length;
    var evdpl_searchcounttext = "results";
    var evdpl_title = 'Search: '+evdpl_searchcount+ ' ' +evdpl_searchcounttext+' found - wkleinberg';
      
    jQuery(document).prop('title',evdpl_title); 
      
    if(evdpl_searchcount > 1 ){
        evdpl_searchcounttext = "results";
    }
    jQuery('body.search .search__results-count').text(evdpl_searchcount+ " "+evdpl_searchcounttext);
    jQuery('body.search .search__results-count').removeClass('hide');
    
    }

      if (jQuery('div').hasClass('evdpl_filtersize')) {
        var divList = jQuery(".evdpl_filtersize .faceted-filter-group-display__list li");
        divList.sort(function (a, b) {
            return $(a).data("listing-sizes") - $(b).data("listing-sizes")
        });
        jQuery(".evdpl_filtersize .faceted-filter-group-display__list").html(divList);
    }

    jQuery(".evdpl_filtersize input[type='checkbox']").click(function () {
        var cls = jQuery(this).data("evdpl-cbtoggle");
        if (jQuery(this).is(":checked")) {
            jQuery("." + cls).prop('checked', true);
        } else {
            jQuery("." + cls).prop('checked', false);
        }
   
  });

  $('.buckle-listing ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg fill='#fff' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg fill='#fff' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
  });

});

// For color reorder
window.addEventListener("DOMContentLoaded", function(){
    // fall back listener if page load not working properly
   jQuery.each(jQuery('.evdpl_filtercolor li'), function () {
            var actualcolor = eval(jQuery(this).data('listing-color'));
            jQuery(this).attr('data-listing-color', actualcolor);
        });

        var divcolorList = jQuery(".evdpl_filtercolor li");
        divcolorList.sort(function (a, b) {
            return jQuery(a).data("listing-color") - jQuery(b).data("listing-color")
        });
   jQuery(".evdpl_filtercolor ul").html(divcolorList);
});

window.addEventListener("DOMContentLoaded", function(){
    // fall back listener if page load not working properly
   jQuery.each(jQuery('.evdpl_filterwidth li'), function () {
            var actualwidth = eval(jQuery(this).data('listing-width'));
            jQuery(this).attr('data-listing-width', actualwidth);
        });

        var divwidthList = jQuery(".evdpl_filterwidth li");
        divwidthList.sort(function (a, b) {
            return jQuery(a).data("listing-width") - jQuery(b).data("listing-width")
        });
   jQuery(".evdpl_filterwidth ul").html(divwidthList);
});